
import waitingForNewRiderImage from "~/assets/images/waitingForNewRiderImage.svg";
export default {
  props: {
    trackingLink: {
      default: "",
      type: String
    },
    orderDetails: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      waitingForNewRiderImage,
      countdown: 180,
      countdownInterval: null
    };
  },
  methods: {
    cancelAndRequestNewRider() {
      this.$emit("cancel-and-request-new-rider");
    },
    startCountdown() {
      const getStartTime = () => {
        const {
          rider_status,
          assignment_delay_type,
          accepted_at,
          ready_at,
          assignment_delay_minutes
        } = this.orderDetails;

        if (rider_status) {
          return rider_status.updated_at;
        }

        const baseTime = new Date(accepted_at).getTime();

        const delayMappings = {
          immediate: accepted_at,
          custom: baseTime + assignment_delay_minutes * 60000,
          prepared: ready_at
        };

        return delayMappings[assignment_delay_type] || null;
      };

      const duration = 180;
      const startTime = getStartTime();

      if (startTime) {
        const elapsedTime = this.getDateTimeDifferenceInSeconds(
          startTime,
          new Date()
        );
        this.countdown = Math.max(duration - elapsedTime, 0);

        if (this.countdown > 0) {
          this.countdownInterval = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
            } else {
              clearInterval(this.countdownInterval);
            }
          }, 1000);
        }
      }
    }
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
};
